import React, {useEffect} from "react";
import {Grid, IconButton} from "@mui/material";
import {ArrowBack} from "@mui/icons-material";
import {RootGrid, HeaderTypography} from "./taxonomy";
import {PocAutoApprovalProperties} from "../../../../settings/default_properties";
import SettingModifier from "../components/setting_modifier";
import {getAttributes as utilGetAttributes} from "../../../../../utils/utils";
import EnhancedErrorDialog from "../../../../../components/EnhancedErrorDialog";
import EnhancedSelectBase from "../../../../../components/EnhancedSelect";
import {pageContentGap} from "../../../../../theme";
const EnhancedSelect = EnhancedSelectBase as any;

interface FormEnhancedSelectProps {
    input: {
        value: string | string[];
        onChange: (value: string | string[]) => void;
    };
    label?: string;
    description?: React.ReactNode;
    isMulti?: boolean;
    options: { Name: string; FriendlyName: string }[];
    labelstyles?: React.CSSProperties;
    labelDescriptionStyles?: React.CSSProperties;
    disabled?: boolean;
}

interface AutoApproveProps {
    setTitle?: (title: string, flag: boolean) => void;
    isRetailer?: boolean;
    location: {
        key?: string;
    };
    history: {
        push: (path: string) => void;
        goBack: () => void;
    };
}

interface ErrorState {
    open: boolean;
    errorHeader: string;
    errorMessage: string;
}

export const FormEnhancedSelect: React.FC<FormEnhancedSelectProps> = (props) => {
    let value: string | string[] = "";
    if(props.input.value === "") value = [];
    else if(Array.isArray(props.input.value)) value = props.input.value;
    else if(typeof props.input.value === "string") value = props.input.value;
    else if(!(props.input.value as string).includes(",")) value = [props.input.value];
    else value = (props.input.value as string).split(",");
    return (
        <EnhancedSelect
            labelstyles={{color: "black", fontWeight: "bold", ...props.labelstyles}}
            labelDescriptionStyles={{color: "#c0c0c0", paddingBottom: "10px", ...props.labelDescriptionStyles}}
            selectorStyle={{}}
            isClearable={true}
            isDisabled={props.disabled}
            label={props.label}
            description={props.description}
            isMulti={props.isMulti}
            options={props.options.map((attribute: { Name: string; FriendlyName: string }) => {
                return {
                    label: attribute.FriendlyName,
                    value: attribute.Name
                }
            })}
            value={
                Array.isArray(value) ?
                    value.map((option: string) => {
                        return {
                            label: option,
                            value: option
                        }
                    })
                    : {
                        label: value,
                        value: value
                    }
            }
            onChange={(e: any) => {
                if(e === null) {
                    props.input.onChange("");
                }
                else if(e.length === 0) {
                    props.input.onChange("");
                }
                else if(Array.isArray(e)) {
                    const formattedValue = e.map((option: { value: string }) => option.value);
                    props.input.onChange(formattedValue);
                }
                else {
                    props.input.onChange(e.value);
                }
            }}
        />
    )
}

const iconButtonSx = (theme: any) => ({
    backgroundColor: "white",
    border: "none",
    borderRadius: "6px",
    "& svg": { color: "rgba(0, 0, 0, 0.54)" }
});

export default function AutoApprove(props: AutoApproveProps) {
    const {setTitle} = props;
    const [error, setError] = React.useState<ErrorState>({open: false, errorHeader: "", errorMessage: ""});
    const [attributes, setAttributes] = React.useState<any[]>([]);
    useEffect(() => {
        if(setTitle) {
            setTitle('POC Auto Approval Settings', true);
        }
        const getAttributes = async () => {
            const attributes = await utilGetAttributes("", (props as any).isRetailer);
            if (attributes.errorMessage) {
                setError(attributes);
            } else {
                setAttributes(attributes);
            }
        }
        getAttributes();
        // eslint-disable-next-line
    }, []);
    return (
        <RootGrid container
              style={{gap: pageContentGap, padding: "24px 14px 24px 14px", position: "relative"}}>
            <Grid container justifyContent={"space-between"} direction={"row"}>
                <Grid container justifyContent={"flex-start"} alignItems={"center"} style={{gap: pageContentGap, width: "100%"}}>
                    <IconButton
                        sx={iconButtonSx}
                        style={{height: "36px", width: "36px", position: 'relative', zIndex: 1}}
                        onClick={(e) => {
                            e.preventDefault();
                            if (props.location.key === undefined)
                                props.history.push("/productonboardingcenter/catalog");
                            else
                                props.history.goBack();
                        }}
                        size="large">
                        <ArrowBack style={{height: "18px", width: "18px"}}/>
                    </IconButton>
                    <HeaderTypography>
                        Auto Approval Settings
                    </HeaderTypography>
                </Grid>
            </Grid>
            <PocAutoApprovalProperties
                isMulti={true}
                options={attributes}
                template={(templateProps: any) => {
                    return <SettingModifier {...templateProps} />
                }}
            />
            <EnhancedErrorDialog open={error.open} onClose={() => setError({...error, open: false})}
                                 errorHeader={error.errorHeader} errorMessage={error.errorMessage}/>
        </RootGrid>
    );
}
